import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'Passengers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetAllDrivers();
        this.GetVehicleTypes();
        this.GetInfo(this.pageNo);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            driverId: null,
            todayDate: new Date().toISOString().split('T')[0],
            ScreenTitle: ' المركبات الموقوفين ',
            ScreenTitleSingle: ' مركب موقوفة ',
            ScreenTitleSingleAl: ' المركب الموقوفة ',
            SuspendReason: '',
            SuspendDriverId: null,
            Info: [],
            Statistics: [],
            DriversList: [],
            vehiclesTypes: {},
            SelectedItem: null,
            ruleFormVehicle: {
                Id: null,
                DriversId: null,
                VehiclesTypesId: null,
                Models: '',
                Years: '',
                PlateNumber: '',
                SeatsCount: null,
                Tier: null,
                InsuranceExpiry: null,
                InspectionExpiry: null,
                /*  IsPrimary: false*/
            },

            vehicleRules: {
                DriversId: this.$helper.Required(),
                VehiclesTypesId: this.$helper.Required(),
                Models: this.$helper.Required(),
                Years: this.$helper.Required(),
                PlateNumber: this.$helper.Required(),
                SeatsCount: this.$helper.Required()
            },
            ruleForm: {
                Id: '',
                UserId: null,
                SchoolsId: null,
                FirstName: '',
                FatherName: '',
                SirName: '',
                Name: '',
                Phone: '',
                Type: 1,
                Descriptions: ''
            },
            rules: {
                Name: this.$helper.Required(),
                Phone: this.$helper.Required(),
                Type: this.$helper.Required()
            }
        };
    },

    methods: {

        openEditVehicleModal(item) {
            this.GetVehicleTypes();
            this.selectedVehicle = item;

            this.ruleFormVehicle = {
                Id: item.id,
                DriversId: item.driversId || this.id,
                VehiclesTypesId: item.vehiclesTypesId || null,
                Models: item.models || '',
                Years: item.years || '',
                PlateNumber: item.plateNumber || '',
                SeatsCount: item.seatsCount,
                Tier: (item.tier === 0 || item.tier) ? Number(item.tier) : null,
                InsuranceExpiry: item.insuranceExpiry
                    ? this.ChangeDate(item.insuranceExpiry)
                    : null,

                InspectionExpiry: item.inspectionExpiry
                    ? this.ChangeDate(item.inspectionExpiry)
                    : null,
                IsPrimary: !!item.isPrimary
            };
        }
        , submitEditVehicle(formRef) {
            const form = this.$refs[formRef];
            if (!form) return;

            form.validate((valid) => {
                if (!valid) return this.$helper.showSwal('warning');

                const body = {
                    Id: Number(this.ruleFormVehicle.Id),
                    DriversId: this.ruleFormVehicle.DriversId,
                    VehiclesTypesId: this.ruleFormVehicle.VehiclesTypesId,
                    Models: this.ruleFormVehicle.Models,
                    Years: this.ruleFormVehicle.Years,
                    PlateNumber: this.ruleFormVehicle.PlateNumber,
                    SeatsCount: this.ruleFormVehicle.SeatsCount,
                    Tier: (this.ruleFormVehicle.Tier === 0 || this.ruleFormVehicle.Tier)
                        ? Number(this.ruleFormVehicle.Tier) : null,
                    InsuranceExpiry: this.ruleFormVehicle.InsuranceExpiry || null,
                    InspectionExpiry: this.ruleFormVehicle.InspectionExpiry || null,
                    IsPrimary: this.ruleFormVehicle.IsPrimary
                };

                this.$blockUI.Start();
                // api/admin/Vehicles/Edit (VehiclesController) هي التي تحفظ Tier.
                this.$http.EditVehicle(body)
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.ClearForm(this.ruleFormVehicle);
                        this.GetInfo();
                        this.$helper.DestroyElemntById('CloseEditVehicle'); // لو حطيتيه
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(
                            'error',
                            'خطأ بعملية التعديل',
                            err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                        );
                    });
            });
        },
        CancelSuspend(Id) {
            Swal.fire({ title: 'إلغاء التعليق', text: 'هل أنت متأكد من إلغاء تعليق المركبة؟', icon: 'question', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false, confirmButtonText: 'نعم' })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.CancelSuspendVehicle(Id)
                            .then(() => { this.$blockUI.Stop(); this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم إلغاء التعليق'); this.GetInfo(this.pageNo); })
                            .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
                    }
                });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetVehiclesSuspended(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    const data = response.data.info || [];

                   
                    const filtered = data.filter(x => Number(x.status) === 4);

                    this.Info = filtered;
                    this.pages = filtered.length;


                  
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                    this.Info = [];
                });
        },
        async GetVehicleTypes() {
            try {
                const res = await this.$http.GetVehicleTypes();
                this.vehiclesTypes = res.data?.info || [];
            } catch (err) {
                this.vehiclesTypes = [];
                this.$helper.ShowMessage(
                    'error',
                    'خطأ',
                    (err?.response?.data) || 'فشل جلب أنواع المركبات'
                );
            }
        },
        GetAllDrivers() {
            this.$http.GetAllDrivers()
                .then(response => {
                    this.DriversList = response.data.info || [];
                })
                .catch(() => {
                    this.DriversList = [];
                });
        },

        applyFilters() {
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },


        submitVehicle(formRef) {
            const form = this.$refs[formRef];
            if (!form) return;

            form.validate((valid) => {
                if (!valid) return this.$helper.showSwal('warning');

                const body = {
                    Id: null,
                    DriversId: this.ruleFormVehicle.DriversId,
                    VehiclesTypesId: this.ruleFormVehicle.VehiclesTypesId,
                    Models: this.ruleFormVehicle.Models,
                    Years: this.ruleFormVehicle.Years,
                    PlateNumber: this.ruleFormVehicle.PlateNumber,
                    SeatsCount: this.ruleFormVehicle.SeatsCount,
                    Tier: (this.ruleFormVehicle.Tier === 0 || this.ruleFormVehicle.Tier)
                        ? Number(this.ruleFormVehicle.Tier) : null,
                    InsuranceExpiry: this.ruleFormVehicle.InsuranceExpiry || null,
                    InspectionExpiry: this.ruleFormVehicle.InspectionExpiry || null,
                    IsPrimary: this.ruleFormVehicle.IsPrimary
                };

                this.$blockUI.Start();
                this.$http.AddVehicle(body)
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                        this.ClearForm(this.ruleFormVehicle);
                        this.GetInfo();
                        this.$helper.DestroyElemntById('CloseAddVehicle'); // لو عندك زر close بهذا id
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(
                            'error',
                            'خطأ بعملية الإضافة',
                            err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع'
                        );
                    });
            });
        }
        ,
        openSuspendModal(Id) {
            this.SuspendDriverId = Id;
            this.SuspendReason = '';
        }, submitSuspend() {
            if (!this.SuspendReason || !this.SuspendDriverId) {
                this.$helper.ShowMessage('error', 'خطأ', 'يرجى إدخال سبب التعليق');
                return;
            }
            this.$blockUI.Start();
            this.$http.SuspendVehicle(this.SuspendDriverId, this.suspendReason)
       
                .then(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تعليق المركبة');
                    this.SuspendDriverId = null;
                    this.SuspendReason = '';
                    this.$helper.DestroyElemntById('CloseSuspend');
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => { this.$blockUI.Stop(); this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ'); });
        },
        DeleteVehicle(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هل انت متأكد من عملية الحذف ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteVehicle(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدث خطأ غير متوقع');
                            }
                        });
                }
            });
        },

        typeLabel(type) {
            if (type === 1) return 'راكب';
            if (type === 2) return 'طالب';
            return type;
        },

        // درجة المركبة: 1=اقتصادية، 2=قياسية، 3=فاخرة.
        tierLabel(tier) {
            const t = Number(tier);
            if (t === 1) return 'اقتصادية';
            if (t === 2) return 'قياسية';
            if (t === 3) return 'فاخرة';
            return '—';
        }
    }
};
